"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workScheduleSlotSequenceApiSchema = exports.workScheduleSlotDoctorAttendingApiSchema = exports.workScheduleSlotApiSchema = void 0;
const zod_1 = require("zod");
const agenda_slot_1 = require("../agenda-slots/agenda-slot");
const api_1 = require("../global/api");
const event_schema_1 = require("../global/event.schema");
exports.workScheduleSlotApiSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('work-schedule-slots'),
    attributes: zod_1.z.object({
        startAt: zod_1.z.coerce.date(),
        endAt: zod_1.z.coerce.date(),
        rrule: event_schema_1.agendaRruleSchema,
        exdate: zod_1.z.array(zod_1.z.string()).optional().default([]),
        /** Consultation mode: `mixed` = présentiel, `fullvisio` = remote video. */
        slotType: agenda_slot_1.agendaSlotTypeSchema.optional().default(agenda_slot_1.PRESENTIEL_SLOT_TYPE),
        withAssistante: zod_1.z.coerce.boolean(),
        forceWithoutAssistant: zod_1.z.coerce.boolean().optional().default(false),
        dayOfWeek: zod_1.z.enum(event_schema_1.daysOfWeek),
        periodOfTheDay: zod_1.z.enum(event_schema_1.periodsOfTheDay),
        sequenceId: zod_1.z.string().uuid().nullable().default(null),
        createdAt: zod_1.z.coerce.date(),
        updatedAt: zod_1.z.coerce.date(),
        medicalAssistantWorkDuration: zod_1.z.number().optional(),
        medicalAssistantWorkPeriods: zod_1.z
            .array(zod_1.z.object({
            startTime: zod_1.z.coerce.date(),
            endTime: zod_1.z.coerce.date(),
            date: zod_1.z.coerce.date(),
        }))
            .optional(),
        reconciliationWarningType: zod_1.z.string().nullable().optional(),
        tag: zod_1.z.string().optional(),
    }),
    relationships: zod_1.z
        .object({
        doctorAttending: (0, api_1.apiEntityRelationshipSchema)('doctor-attendings').optional(),
        sequence: (0, api_1.apiEntityRelationshipSchema)('work-schedule-slots').optional(),
    })
        .optional()
        .default({}),
});
exports.workScheduleSlotDoctorAttendingApiSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('doctor-attendings'),
    attributes: zod_1.z.object({
        firstname: zod_1.z.string(),
        lastname: zod_1.z.string(),
        rhythm: zod_1.z.string().optional(),
        onSiteSlotsWithoutAssistant: zod_1.z.number().nullable().optional(),
        remoteSlotsWithoutAssistant: zod_1.z.number().nullable().optional(),
        onSiteSlotsWithAssistant: zod_1.z.number().nullable().optional(),
        remoteSlotsWithAssistant: zod_1.z.number().nullable().optional(),
        rhythmNote: zod_1.z.string().nullable().optional(),
    }),
});
exports.workScheduleSlotSequenceApiSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('work-schedule-slots'),
    attributes: zod_1.z.object({
        startAt: zod_1.z.coerce.date(),
        endAt: zod_1.z.coerce.date(),
        rrule: event_schema_1.agendaRruleSchema,
        exdate: zod_1.z.array(zod_1.z.string()).optional().default([]),
        sourceId: zod_1.z.string().uuid().nullable().default(null),
        withAssistante: zod_1.z.coerce.boolean(),
        dayOfWeek: zod_1.z.enum(event_schema_1.daysOfWeek),
        periodOfTheDay: zod_1.z.enum(event_schema_1.periodsOfTheDay),
        occurenceIndex: zod_1.z.number().optional(),
        createdAt: zod_1.z.coerce.date(),
    }),
});
